import React, { useEffect } from 'react'
import { useTX } from '@transifex/react'

import { TCoreIoUserLanguageChoices } from '../api/consts'
import { useMe } from '../hooks'

const transifexLangMap: Record<TCoreIoUserLanguageChoices, string> = {
  DA: 'da',
  EN: 'en',
  NO: 'no_NO',
  FI: 'fi',
  SV: 'sv',
}

/**
 * Set transifex language based on user setting
 */
const Transifex = () => {
  const me = useMe()
  const tx = useTX()

  const forceLocale = process.env.REACT_APP_FORCE_LOCALE
  const userLanguage = me?.language as TCoreIoUserLanguageChoices

  useEffect(() => {
    // Allow forcing locale via env var (for development)
    if (forceLocale) {
      tx.setCurrentLocale(forceLocale)
      return
    }

    if (userLanguage) {
      // Convert to uppercase to match map keys (backend returns lowercase)
      const upperLanguage = userLanguage.toUpperCase() as TCoreIoUserLanguageChoices
      const transifexLocale = transifexLangMap[upperLanguage]
      if (transifexLocale) {
        tx.setCurrentLocale(transifexLocale)
      } else {
        // eslint-disable-next-line no-console
        console.log(
          new Error(`
        User language: ${userLanguage} is not supported by transifex.
        Setting language to en as fallback.
        `)
        )
      }
    }
  }, [userLanguage, tx, forceLocale])

  return <></>
}

export default Transifex
